/* eslint-disable react/prop-types */
import React, { useMemo, useState } from "react";
import { ethers } from "ethers";
// import { networkConfig } from "../../const";
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import Button from "../../components/CustomButtons/Button";

const targetChainEnv = process.env.REACT_APP_CHAIN_ID;

// eslint-disable-next-line react/prop-types
export default function NetworkDialog({
  open,
  onClose,
  title,
  action,
  callApi,
  onDone,
}) {
  const targetChain = localStorage.getItem("rowChainIdTemp") || targetChainEnv;
  const [wallet, setWallet] = useState();
  const [chainId, setChainId] = useState();
  const [msg, setMsg] = useState("");
  const connected = useMemo(
    () => wallet && +chainId === +targetChain,
    [wallet, chainId]
  );
  const signer = useMemo(() => {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    return provider.getSigner();
  }, [wallet, chainId]);
  const [running, setRunning] = useState(false);
  const [tx, setTx] = useState("");
  const [success, setSuccess] = useState(false);

  const start = async () => {
    setRunning(true);
    try {
      const { transaction, data } = await action(signer);
      setTx(transaction.hash);
      await transaction.wait();
      await callApi(data);
      setSuccess(true);
      onDone();
    } catch (err) {
      console.log(err);
      setMsg(err.message);
    } finally {
      setRunning(false);
    }
  };

  const connectWallet = async () => {
    const { ethereum } = window;
    if (ethereum.isMetaMask) {
      const provider = new ethers.providers.Web3Provider(ethereum);
      const accounts = await provider.send("eth_requestAccounts", []);

      const { chainId } = await provider.getNetwork();

      setChainId(chainId);
      setWallet(accounts[0]);
    } else {
      setMsg("Install MetaMask");
    }
  };

  const switchNetwork = async () => {
    try {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: ethers.utils.hexValue(parseInt(targetChain, 10)) }],
      });
      setChainId(targetChain);
    } catch (error) {
      setMsg(error);
    }
  };

  return (
    <Dialog open={open} size="lg" disableEscapeKeyDown={true}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {wallet && (
          <div>
            <strong>Connected:</strong> {wallet}
          </div>
        )}

        {tx && (
          <div>
            <strong>Transaction:</strong> {tx}
          </div>
        )}
        {msg}

        {running && <CircularProgress />}

        {success && <strong>Success</strong>}

        {!connected && (
          <div>
            {wallet ? (
              <Button onClick={switchNetwork}>Switch network</Button>
            ) : (
              <Button onClick={connectWallet}>Connect wallet</Button>
            )}
          </div>
        )}
      </DialogContent>
      <DialogActions>
        {!success && (
          <Button
            disabled={!connected || running}
            onClick={start}
            color="success"
          >
            Start
          </Button>
        )}
        {!running && (
          <Button onClick={() => onClose()} color="danger">
            Close
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
